import React, { useState } from "react";
import "./id-card-config.scss";

const TransferCertificate = () => {
    const TransferStudents = [
        {
            name: "U. Sathvika",
            father: "U. Raviteja",
            mother: "U. Naga Swetha",
            admission: "252628",
            className: "PP-1",
            section: "A",
            course: "PRE PRIMARY",
            dob: "09 Feb 2021",
            curriculum: "SSC",
            academic_year: "2026-27"
        },
        {
            name: "Rahul Kumar",
            father: "Ramesh Kumar",
            mother: "Sunita Kumar",
            admission: "252629",
            className: "1st",
            section: "B",
            course: "PRIMARY",
            dob: "14 Aug 2019",
            curriculum: "CBSE",
            academic_year: "2026-27"
        }
    ];

    const [searchTransfer, setSearchTransfer] = useState("");
    const [showListTransfer, setShowListTransfer] = useState(false);

    const [formData, setFormData] = useState({
        academic_year: "",
        curriculum: "",
        className: "",
        section: "",
        student: "",
        father: "",
        mother: "",
        admissionNo: "",
        course: "",
        dob: "",
        conduct: "Good",
        certNo: "36/2026",
        date: "19 Jun 2026"
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const selectStudent = (stu) => {
        setSearchTransfer(stu.name);
        setFormData(prev => ({
            ...prev,
            student: stu.name,
            father: stu.father,
            mother: stu.mother,
            admissionNo: stu.admission,
            className: stu.className,
            section: stu.section,
            course: stu.course,
            dob: stu.dob,
            curriculum: stu.curriculum,
            academic_year: stu.academic_year
        }));
        setShowListTransfer(false);
    }

    const filteredStudents = TransferStudents.filter(item =>
        item.name.toLowerCase().includes(searchTransfer.toLowerCase())
    );

    const displayValue = (value) => {
        return value && value.trim() !== "" ? value : "________";
    }

    return (
        <div className="mt-3">
            {/* FILTER */}
            <div className="card no-print">
                <div className="card-header">
                    Generate Transfer Certificate
                </div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <label>Academic Year</label>
                            <select
                                className="form-select"
                                name="academic_year"
                                value={formData.academic_year}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option>2026-27</option>
                                <option>2025-26</option>
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label>Curriculum</label>
                            <select
                                className="form-select"
                                name="curriculum"
                                value={formData.curriculum}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option>SSC</option>
                                <option>CBSE</option>
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label>Class</label>
                            <select
                                className="form-select"
                                name="className"
                                value={formData.className}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option>PP-1</option>
                                <option>PP-2</option>
                                <option>1st</option>
                                <option>2nd</option>
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label>Section</label>
                            <select
                                className="form-select"
                                name="section"
                                value={formData.section}
                                onChange={handleChange}
                            >
                                <option value="">Select</option>
                                <option>A</option>
                                <option>B</option>
                            </select>
                        </div>

                        <div className="col-md-3 position-relative">
                            <label>Student</label>
                            <input
                                className="form-control"
                                value={searchTransfer}
                                autoComplete="off"
                                data-gramm="false"
                                data-gramm_editor="false"
                                data-enable-grammarly="false"
                                onChange={(e) => {
                                    setSearchTransfer(e.target.value);
                                    setShowListTransfer(true);
                                }}
                                onFocus={() => setShowListTransfer(true)}
                            />
                            <div
                                className="transfer-student-list"
                                style={{ display: showListTransfer && searchTransfer ? "block" : "none" }}
                            >
                                {filteredStudents.map((stu) => (
                                    <div key={stu.admission} onMouseDown={() => selectStudent(stu)}>
                                        <b>{stu.name}</b>
                                        <br />
                                        Father : {stu.father}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label>Conduct</label>
                            <select
                                className="form-select"
                                name="conduct"
                                value={formData.conduct}
                                onChange={handleChange}
                            >
                                <option>Excellent</option>
                                <option>Good</option>
                                <option>Satisfactory</option>
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label>Cert. No</label>
                            <input
                                className="form-control"
                                name="certNo"
                                value={formData.certNo}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3">
                            <label>Date</label>
                            <input
                                type="date"
                                className="form-control"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* CERTIFICATE */}
            <div className="transfer-print-area">
                <div className="transfer-page">
                    <div className="transfer-certificate">
                        <div className="transfer-certificate-frame">

                            <span className="transfer-corner transfer-corner-tl"></span>
                            <span className="transfer-corner transfer-corner-tr"></span>
                            <span className="transfer-corner transfer-corner-bl"></span>
                            <span className="transfer-corner transfer-corner-br"></span>

                            <div className="transfer-logo-box">
                                <img src="https://www.srinitheplayschool.com/img/logo.png" alt="logo" />
                            </div>

                            <h2 className="transfer-school-name">
                                SRINI THE PLAY SCHOOL &amp; ACADEMY
                            </h2>

                            <div className="transfer-subtitle-row">
                                <span className="transfer-line"></span>
                                <span className="transfer-label">TRANSFER CERTIFICATE</span>
                                <span className="transfer-line"></span>
                            </div>

                            <div className="transfer-meta-row">
                                <span>Cert. No: {displayValue(formData.certNo)}</span>
                                <span>Date: {displayValue(formData.date)}</span>
                            </div>

                            <div className="transfer-body">
                                <p>
                                    This is to certify that <b>{displayValue(formData.student)}</b>,
                                    son/daughter of <b>{displayValue(formData.father)}</b> and{" "}
                                    <b>{displayValue(formData.mother)}</b>, bearing Admission No.{" "}
                                    <b>{displayValue(formData.admissionNo)}</b>, was a bonafide student of this institution.
                                </p>

                                <p>
                                    The student was enrolled in Class{" "}
                                    <b>{displayValue(formData.className)} — {displayValue(formData.section)}</b>{" "}
                                    and has successfully completed the prescribed course of study.
                                </p>

                                <p>
                                    Date of Birth as per school records: <b>{displayValue(formData.dob)}</b>
                                </p>

                                <p>
                                    The student's conduct and character throughout the period of study was{" "}
                                    <b>{displayValue(formData.conduct)}</b>. He/She leaves the institution on his/her
                                    own accord and is hereby issued this Transfer Certificate to facilitate admission
                                    into another institution.
                                </p>

                                <p>
                                    We wish <b>{displayValue(formData.student)}</b> all the very best in future
                                    academic pursuits and endeavors.
                                </p>
                            </div>

                            <div className="transfer-seal">
                                {/* <span>OFFICIAL</span> */}
                                <span>SEAL</span>
                            </div>

                            <div className="transfer-footer">
                                <div>
                                    Date: {displayValue(formData.date)}
                                </div>

                                <div className="transfer-signatures">
                                    <div className="transfer-sig-line">
                                        <div className="transfer-sig-rule"></div>
                                        Principal Signature
                                    </div>
                                    <div className="transfer-sig-line">
                                        <div className="transfer-sig-rule"></div>
                                        Principal
                                        <br />
                                        SRINI THE PLAY SCHOOL &amp; ACADEMY
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="no-print text-center">
                <button
                    className="btn btn-success mt-3"
                    onClick={() => window.print()}
                >
                    Print Certificate
                </button>
            </div>
        </div>
    )
}

export default TransferCertificate;